
/* Single image */
import simg1 from '../images/service-single/1.jpg'
import simg2 from '../images/service-single/2.jpg'
import simg3 from '../images/service-single/3.jpg'
import simg4 from '../images/service-single/4.jpg'
import simg5 from '../images/service-single/5.jpg'
import simg6 from '../images/service-single/6.jpg'

/* Treatment Icons */
import jointPainIcon from '../images/services/Joint Pain & Arthritis Solutions.jpg'
import sexualWellnessIcon from '../images/services/Sexual Wellness & Performance.jpg'
import chronicPainIcon from '../images/services/Chronic Pain Management.jpg'
import neurologicalIcon from '../images/services/Neurological Recovery & Support.jpg'
import athleticIcon from '../images/services/Athletic Performance & Sports Medicine.jpg'
import antiAgingIcon from '../images/services/Anti-Aging & Longevity.jpg'



const Services = [
    {
        id: 1,
        icon: jointPainIcon,
        simage: simg1,
        title: 'Joint Pain & Arthritis Solutions',
        description: 'Wharton\'s Jelly MSC therapy, Advanced PRP/BMAC protocols, Non-surgical joint regeneration, 25+ years procedural expertise',
        slug: 'joint-pain-arthritis'
    },
    {
        id: 2,
        icon: sexualWellnessIcon,
        simage: simg2,
        title: 'Sexual Wellness & Performance',
        description: 'Regenerative intimate health protocols, Performance enhancement programs, Men\'s and women\'s wellness solutions, Confidential consultation process',
        slug: 'sexual-wellness-performance'
    },
    {
        id: 3,
        icon: chronicPainIcon,
        simage: simg3,
        title: 'Chronic Pain Management',
        description: 'Dr. Pereira\'s 25+ years expertise, FIPP & ABIPP certified procedures, Advanced interventional techniques, Root cause regenerative solutions',
        slug: 'chronic-pain-management'
    },
    {
        id: 4,
        icon: neurologicalIcon,
        simage: simg4,
        title: 'Neurological Recovery & Support',
        description: 'Neurodegenerative condition protocols, Post-stroke recovery programs, Autoimmune support therapies, Neuroprotective treatments',
        slug: 'neurological-recovery'
    },
    {
        id: 5,
        icon: athleticIcon,
        simage: simg5,
        title: 'Athletic Performance & Sports Medicine',
        description: 'Sports injury regeneration, Performance optimization protocols, Recovery acceleration therapies, Professional athlete treatments',
        slug: 'athletic-performance'
    },
    {
        id: 6,
        icon: antiAgingIcon,
        simage: simg6,
        title: 'Anti-Aging & Longevity',
        description: 'Systemic cellular regeneration, Cardiovascular health optimization, Vitality enhancement protocols, Comprehensive wellness programs',
        slug: 'anti-aging-longevity'
    },
    {
        id: 7,
        icon: athleticIcon,
        simage: simg1,
        title: 'Sports Medicine and Men\'s Health',
        description: 'Advanced sports injury recovery protocols, Men\'s hormonal optimization, Performance enhancement therapies, Specialized regenerative treatments for male wellness',
        slug: 'sports-medicine-mens-health'
    },
    {
        id: 8,
        icon: neurologicalIcon,
        simage: simg2,
        title: 'Neurodegenerative and Dementia Therapy',
        description: 'Alzheimer\'s and dementia support protocols, Cognitive enhancement therapies, Neuroprotective stem cell treatments, Memory preservation programs',
        slug: 'neurodegenerative-dementia'
    },
    {
        id: 9,
        icon: neurologicalIcon,
        simage: simg3,
        title: 'Developmental Disorders - Autism Spectrum',
        description: 'Specialized protocols for autism spectrum disorders, Neurodevelopmental support therapies, Pediatric regenerative medicine, Family-centered treatment approach',
        slug: 'developmental-disorders-autism'
    },
    {
        id: 10,
        icon: jointPainIcon,
        simage: simg4,
        title: 'Muse Cell Therapy (M-U-S-E cells)',
        description: 'Advanced pluripotent stem cell therapy, Multi-lineage regenerative potential, Targeted tissue repair protocols, Cutting-edge cellular medicine. All stem cells are ethically sourced and of the highest quality purification and count.',
        slug: 'muse-cell-therapy'
    },





];
export default Services;